import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './ChartTooltip.css';

const ChartTooltip = (props) => {
    if (!props.data) return null;
    const {
        data: { data, headers, label },
        format
    } = props;

    if (!data || !headers || !label) return null;

    return (
        <div className="tooltip-container">
            <div className="title wrap-title">{label}</div>
            <div className="data-container wrap-name">
                {headers.map((ele, i) => (
                    <React.Fragment key={ele}>
                        <div className="data-label">{ele}</div>
                        <div className={cn('data-value', { blue: i === 0 })}>
                            {format(data[i])}
                        </div>
                    </React.Fragment>
                ))}
            </div>

            <style jsx>{styles}</style>
        </div>
    );
};

ChartTooltip.propTypes = {
    /**
     * Function to format data to display
     */
    format: PropTypes.func
};

ChartTooltip.defaultProps = {
    format: (val) => val
};

export default ChartTooltip;
